import EDPanel from '../../../../../BaseComponents/Panel/EDPanel';
import EDIcon from '../../../../../BaseComponents/Icon/EDIcon';

const Favorites = () => (
  <EDPanel
    title="Favoriter"
    subtitle="Alla enheter"
    avatar={<EDIcon color="action" iconType="bookmark" size="large" />}
    headerPadding="normal"
    flex
  />
);

export default Favorites;
